import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxMaskModule, IConfig } from "ngx-mask";
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTableModule} from '@angular/material/table'
import { MatInputModule, MatPaginatorModule, MatToolbarModule, MatIconModule,  MatButtonModule, MatDialogModule, MatOptionModule, MatOption, MatSelectModule, MatAutocompleteModule, MatRadioButton, MatRadioGroup, MatRippleModule, MatTooltipModule, MatListModule, MatGridListModule, MatDialogTitle, MatStepperModule} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

export var options: Partial<IConfig> | (() => Partial<IConfig>);


@NgModule({
    imports: [FormsModule, ReactiveFormsModule ,CommonModule, TranslateModule,
        MatStepperModule,
        MatGridListModule ,MatListModule,MatTabsModule, MatDatepickerModule, MatFormFieldModule, MatTableModule, MatInputModule,
        MatPaginatorModule, MatToolbarModule, MatIconModule, MatButtonModule, MatDialogModule, MatSelectModule, MatAutocompleteModule, MatRippleModule, MatTooltipModule,
        NgxMaskModule.forRoot()
    ],

    declarations: [ ],
    entryComponents:[]

})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/modules/shared.module.ts